import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Box, Text } from '@qga/roo-ui/components';
import DreamPlannerLink from '../DreamPlannerLink';

const ButtonLabel = ({ isAuthenticated, isFavourite, hasError }) => (
  <Box data-testid="button-label">
    {!isAuthenticated && !hasError && (
      <Fragment>
        <Text pr={1}>Login to save to</Text>
        <DreamPlannerLink />
      </Fragment>
    )}

    {isAuthenticated && hasError && <Text pr={4}>We are unable to save to Dream Planner, please try again later.</Text>}

    {isAuthenticated && !hasError && !isFavourite && (
      <Fragment>
        <Text pr={1}>Save to</Text>
        <DreamPlannerLink />
      </Fragment>
    )}

    {isAuthenticated && !hasError && isFavourite && (
      <Fragment>
        <Text pr={1}>View in</Text>
        <DreamPlannerLink />
      </Fragment>
    )}
  </Box>
);

ButtonLabel.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isFavourite: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
};

export default ButtonLabel;
